<template>
  <Head>
    <Title>Rodina v přírodě - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Rodina v přírodě</h1>
      <div class="mb-5">
        <br>
        Rodinné momenty v přírodě – umění, které mluví k srdci
        <br><br>
        Vytvářím umělecké fotografie, které zachycují přirozené okamžiky rodinného života v nádherném prostředí přírody. 
        Krása Vašich emocí je podtržena a doplněna krásou přírody, což dává fotografiím jedinečný a nezapomenutelný nádech. 
        Každá fotografie vypráví příběh o lásce, spojení a radosti, a bude Vás těšit po celý život.
      
        <br><br>
        Chcete někomu udělat radost? Toto focení si můžete koupit jako dárek. Mám pro vás připravené krásné dárkové poukazy.
        <br><br>
        Rezervace termínu nebo objednávka poukazu v soukromých zprávách.
        <br><br>
      </div>
    </v-sheet>
    <v-row v-for="index in 21">
      <v-col cols="12" md="6">
        <v-img :src="'nature/' + (index * 2 - 1) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'nature/' + (index * 2) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
    </v-row>
  </v-container>
</template>